var map = {
	"./cagayan-cert.webp": 1959,
	"./cert-bg.webp": 1960,
	"./isle-cert.webp": 1961,
	"./license-bg-cn.webp": 1962,
	"./license-bg-mobile-cn.webp": 1963,
	"./license-bg-mobile.webp": 1964,
	"./license-bg.webp": 1965,
	"./pagcor-cert.webp": 1966,
	"./page-bg.webp": 1967
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 896;